/* Qazira — interactive behaviors */
(function () {
  'use strict';

  const root = document.documentElement;
  const body = document.body;
  const ROUTES = (window.Shopify && window.Shopify.routes) || { root: '/' };

  // ---------- Helpers ----------
  const $  = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const money = (cents) => {
    const format = (window.Qazira && window.Qazira.moneyFormat) || '${{amount}}';
    return format.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  };
  const fetchJSON = (url, opts = {}) =>
    fetch(url, { headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, ...opts })
      .then(r => r.json());
  // Escape HTML special chars so user-controlled strings (cart/Shopify content)
  // can't break out of attributes or inject markup.
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (ch) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]
  ));

  // ---------- Sticky header on scroll ----------
  const header = $('.qz-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-solid', window.scrollY > 30);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---------- Mobile nav ----------
  const burger = $('[data-qz-burger]');
  const mobileNav = $('.qz-mobile-nav');
  const mobileNavOverlay = $('[data-qz-mobile-overlay]');

  const openMobileNav = () => {
    mobileNav?.classList.add('is-open');
    mobileNavOverlay?.classList.add('is-open');
    burger?.classList.add('is-open');
    burger?.setAttribute('aria-expanded', 'true');
    burger?.setAttribute('aria-label', 'Close menu');
    mobileNav?.setAttribute('aria-hidden', 'false');
    body.classList.add('qz-no-scroll');
  };
  const closeMobileNav = () => {
    mobileNav?.classList.remove('is-open');
    mobileNavOverlay?.classList.remove('is-open');
    burger?.classList.remove('is-open');
    burger?.setAttribute('aria-expanded', 'false');
    burger?.setAttribute('aria-label', 'Open menu');
    mobileNav?.setAttribute('aria-hidden', 'true');
    body.classList.remove('qz-no-scroll');
  };

  if (burger && mobileNav) {
    burger.addEventListener('click', () => {
      mobileNav.classList.contains('is-open') ? closeMobileNav() : openMobileNav();
    });
    mobileNavOverlay?.addEventListener('click', closeMobileNav);
    $('[data-qz-mobile-close]', mobileNav)?.addEventListener('click', closeMobileNav);
    $$('.qz-mobile-nav a').forEach(a => a.addEventListener('click', closeMobileNav));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMobileNav();
    });
  }

  // ---------- Cart drawer ----------
  const drawer  = $('#qz-cart-drawer');
  const overlay = $('#qz-overlay');
  const cartCountEls = $$('[data-qz-cart-count]');
  const openCart  = () => { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); body.style.overflow = 'hidden'; };
  const closeCart = () => { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); body.style.overflow = ''; };

  $$('[data-qz-cart-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); refreshCart().then(openCart); }));
  $('[data-qz-cart-close]')?.addEventListener('click', closeCart);
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer?.classList.contains('is-open')) closeCart(); });

  const setCartCount = (n) => cartCountEls.forEach(el => { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });

  function renderCart(cart) {
    const body = $('[data-qz-cart-body]');
    const subtotal = $('[data-qz-cart-subtotal]');
    const progress = $('[data-qz-cart-progress]');
    const progressText = $('[data-qz-cart-progress-text]');
    if (!body) return;

    setCartCount(cart.item_count);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="qz-cart-empty">
          <p>Your cart feels calm and empty.</p>
          <a class="qz-btn qz-btn--primary" href="${ROUTES.root}collections/all">Discover Products</a>
        </div>`;
      subtotal && (subtotal.textContent = money(0));
      progress && (progress.style.width = '0%');
      progressText && (progressText.textContent = 'Add ' + money(1000) + ' for free shipping');
      return;
    }

    body.innerHTML = cart.items.map((item, i) => `
      <div class="qz-cart-item" data-line="${i + 1}">
        <a class="qz-cart-item__media" href="${esc(item.url)}">
          <img src="${esc(item.image)}" alt="${esc(item.product_title)}" loading="lazy">
        </a>
        <div>
          <a href="${esc(item.url)}" class="qz-cart-item__title">${esc(item.product_title)}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="qz-cart-item__variant">${esc(item.variant_title)}</div>` : ''}
          <div class="qz-cart-item__qty">
            <button type="button" data-qz-qty="-" aria-label="Decrease">&minus;</button>
            <span>${item.quantity}</span>
            <button type="button" data-qz-qty="+" aria-label="Increase">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div class="qz-cart-item__price">${money(item.final_line_price)}</div>
          <button type="button" class="qz-cart-item__remove" data-qz-remove>Remove</button>
        </div>
      </div>
    `).join('');

    subtotal && (subtotal.textContent = money(cart.total_price));

    const threshold = 1000; // free shipping at $10
    const pct = Math.min(100, (cart.total_price / threshold) * 100);
    progress && (progress.style.width = pct + '%');
    if (progressText) {
      if (cart.total_price >= threshold) {
        progressText.textContent = "You've unlocked free shipping.";
      } else {
        progressText.textContent = 'Add ' + money(threshold - cart.total_price) + ' more for free shipping';
      }
    }

    $$('.qz-cart-item', body).forEach((row) => {
      const line = parseInt(row.dataset.line, 10);
      row.querySelector('[data-qz-qty="+"]').addEventListener('click', () => changeLine(line, +1));
      row.querySelector('[data-qz-qty="-"]').addEventListener('click', () => changeLine(line, -1));
      row.querySelector('[data-qz-remove]').addEventListener('click', () => updateLine(line, 0));
    });
  }

  function refreshCart() {
    return fetchJSON(ROUTES.root + 'cart.js').then(cart => { renderCart(cart); return cart; });
  }

  function changeLine(line, delta) {
    return fetchJSON(ROUTES.root + 'cart.js').then(cart => {
      const current = cart.items[line - 1];
      if (!current) return;
      const newQty = Math.max(0, current.quantity + delta);
      return updateLine(line, newQty);
    });
  }
  function updateLine(line, quantity) {
    return fetchJSON(ROUTES.root + 'cart/change.js', {
      method: 'POST',
      body: JSON.stringify({ line, quantity })
    }).then(renderCart);
  }

  // Intercept product form submits — add to cart via fetch, open drawer
  $$('[data-qz-add-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      submit && submit.setAttribute('disabled', 'disabled');
      const fd = new FormData(form);
      fetch(ROUTES.root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' }})
        .then(r => r.json())
        .then(() => refreshCart())
        .then(openCart)
        .catch((err) => console.error('Add to cart failed', err))
        .finally(() => submit && submit.removeAttribute('disabled'));
    });
  });

  // Quick add buttons (no variant prompt — first available variant)
  $$('[data-qz-quick-add]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const id = btn.dataset.qzQuickAdd;
      if (!id) return;
      fetch(ROUTES.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
      }).then(() => refreshCart()).then(openCart);
    });
  });

  // Initial cart sync (for count badge)
  if (window.Shopify) refreshCart();

  // ---------- Wishlist (localStorage) ----------
  const WL_KEY = 'qazira:wishlist';
  const wishlistGet = () => { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch { return []; } };
  const wishlistSet = (arr) => localStorage.setItem(WL_KEY, JSON.stringify(arr));
  const wlButtons = () => $$('[data-qz-wishlist]');
  const paintWishlist = () => {
    const list = wishlistGet();
    wlButtons().forEach(btn => btn.classList.toggle('is-active', list.includes(btn.dataset.qzWishlist)));
  };
  paintWishlist();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qz-wishlist]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.qzWishlist;
    let list = wishlistGet();
    if (list.includes(id)) list = list.filter(x => x !== id); else list.push(id);
    wishlistSet(list);
    paintWishlist();
  });

  // ---------- Recently viewed (localStorage) ----------
  const RV_KEY = 'qazira:recently-viewed';
  const rvGet = () => { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch { return []; } };
  const rvSet = (arr) => localStorage.setItem(RV_KEY, JSON.stringify(arr.slice(0, 8)));
  const productHandle = document.body.dataset.qzProductHandle;
  if (productHandle) {
    const list = rvGet().filter(h => h !== productHandle);
    list.unshift(productHandle);
    rvSet(list);
  }

  // ---------- Testimonials nav ----------
  const track = $('[data-qz-test-track]');
  if (track) {
    const step = () => Math.min(track.clientWidth * .8, 360);
    $('[data-qz-test-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    $('[data-qz-test-next]')?.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
  }

  // ---------- Exit-intent popup ----------
  const modal = $('#qz-exit-modal');
  const modalShownKey = 'qazira:exit-shown';
  const showModal = () => {
    if (!modal || sessionStorage.getItem(modalShownKey)) return;
    modal.classList.add('is-open');
    sessionStorage.setItem(modalShownKey, '1');
  };
  if (modal) {
    document.addEventListener('mouseout', (e) => {
      if (!e.toElement && !e.relatedTarget && e.clientY < 5) showModal();
    });
    // Timed fallback after 60s
    setTimeout(showModal, 60000);
    $('[data-qz-modal-close]', modal)?.addEventListener('click', () => modal.classList.remove('is-open'));
    modal.addEventListener('click', (e) => { if (e.target === modal) modal.classList.remove('is-open'); });
  }

  // ---------- Social proof toast ----------
  const toast = $('#qz-toast');
  if (toast) {
    const data = window.Qazira?.socialProof || [];
    let idx = 0;
    const cycle = () => {
      if (!data.length) return;
      const item = data[idx % data.length];
      toast.innerHTML = `
        ${item.image ? `<img src="${esc(item.image)}" alt="">` : ''}
        <div>
          <strong>${esc(item.who)} from ${esc(item.where)}</strong>
          <small>bought ${esc(item.product)} · ${esc(item.when)}</small>
        </div>`;
      toast.classList.add('is-on');
      setTimeout(() => toast.classList.remove('is-on'), 5000);
      idx++;
    };
    setTimeout(() => { cycle(); setInterval(cycle, 12000); }, 8000);
  }

  // ---------- Product page: gallery + variants + sticky ----------
  const gallery = $('[data-qz-gallery]');
  if (gallery) {
    const main = $('[data-qz-gallery-main] img', gallery);
    $$('[data-qz-gallery-thumb]', gallery).forEach((thumb) => {
      thumb.addEventListener('click', () => {
        $$('[data-qz-gallery-thumb]', gallery).forEach(t => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.src;
      });
    });
  }

  $$('[data-qz-variant-group]').forEach((group) => {
    group.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('button').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        updateVariantHidden();
      });
    });
  });
  function updateVariantHidden() {
    const hidden = $('[data-qz-variant-id-input]');
    if (!hidden || !window.Qazira?.productVariants) return;
    const selected = $$('[data-qz-variant-group]').map(g => g.querySelector('button.is-active')?.dataset.value).filter(Boolean);
    const match = window.Qazira.productVariants.find(v => v.options.every((opt, i) => opt === selected[i]));
    if (match) {
      hidden.value = match.id;
      const priceEl = $('[data-qz-product-price]');
      if (priceEl) priceEl.innerHTML = match.price_html;
    }
  }
  // Sticky add-to-cart visibility
  const stickyAdd = $('.qz-product__sticky');
  const productCta = $('.qz-product__cta-row');
  if (stickyAdd && productCta && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      stickyAdd.style.display = entry.isIntersecting ? 'none' : '';
    }, { threshold: 0 });
    io.observe(productCta);
  }

  // Qty steppers on product page
  $$('[data-qz-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[type="number"]');
    wrap.querySelector('[data-qz-qty-minus]')?.addEventListener('click', () => { if (input.value > 1) input.value = +input.value - 1; });
    wrap.querySelector('[data-qz-qty-plus]')?.addEventListener('click', () => input.value = +input.value + 1);
  });

  // ---------- Summer sale popup (auto-show + auto-dismiss) ----------
  const salePopup = $('[data-qz-sale-popup]');
  if (salePopup) {
    const SALE_KEY = 'qazira:sale-popup-dismissed';
    const delay = Math.max(0, parseInt(salePopup.dataset.qzSaleDelay, 10) || 1200);
    const seconds = Math.max(2, parseInt(salePopup.dataset.qzSaleDuration, 10) || 7);
    let autoTimer = null;

    const openSale = () => {
      if (sessionStorage.getItem(SALE_KEY)) return;
      salePopup.style.setProperty('--qz-sale-duration', seconds + 's');
      salePopup.classList.add('is-open');
      salePopup.setAttribute('aria-hidden', 'false');
      autoTimer = setTimeout(closeSale, seconds * 1000);
    };
    const closeSale = () => {
      salePopup.classList.remove('is-open');
      salePopup.setAttribute('aria-hidden', 'true');
      sessionStorage.setItem(SALE_KEY, '1');
      if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; }
    };

    $$('[data-qz-sale-close]', salePopup).forEach((b) => b.addEventListener('click', closeSale));
    // Tapping outside (clicking the CTA also closes via navigation)
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && salePopup.classList.contains('is-open')) closeSale();
    });
    // Cancel auto-dismiss while the user is interacting with the card
    salePopup.addEventListener('mouseenter', () => { if (autoTimer) { clearTimeout(autoTimer); autoTimer = null; } });
    salePopup.addEventListener('mouseleave', () => { if (!autoTimer) autoTimer = setTimeout(closeSale, 3000); });

    setTimeout(openSale, delay);
  }

  // FAQ — accordion (details element is native, but smooth-animate height)
  $$('.qz-faq__item').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        $$('.qz-faq__item').forEach(d => { if (d !== details) d.open = false; });
      }
    });
  });
})();
